/* eslint no-prototype-builtins: "off" */

'use strict';

let catalogs = {};
let localeFallback = 'en';
let locale = localeFallback;

catalogs.en = require('../i18n/en_EN');
catalogs.fr = require('../i18n/fr_FR');

const availableLangs = ['fr', 'en'];

/**
 * Translator allow to change locale, translate sentence
 *
 * @module core/translator
 * @author Julien Trollé <julien.trolle@lp-digital.fr>
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
module.exports = {
  /**
   * Initialize the user lang and define the locale
   *
   * @example translator.init();
   */
  init: function() {
    const userLang = navigator.language || navigator.userLanguage;
    const storage = localStorage.getItem('locale');

    if (!storage) {
      if (userLang) {
        let lang = userLang.substring(0, 2);
        this.setLocale(availableLangs.indexOf(lang) !== -1 ? lang : localeFallback);
      } else {
        this.setLocale(localeFallback);
      }
    } else {
      this.setLocale(storage);
    }
  },

  /**
   * Return the current locale
   *
   * @example translator.getLocale();
   * @returns {string} locale
   */
  getLocale: function() {
    return locale;
  },

  /**
   * Set the locale and put in the local storage
   *
   * @example translator.setLocale('fr');
   * @param {string} l
   */
  setLocale: function(l) {
    locale = l;
    localStorage.setItem('locale', locale);
  },

  /**
   * Set the catalog
   *
   * @example translator.setCatalog('fr', {'name': 'Nom'});
   * @param {string} lang
   * @param {object} data
   */
  setCatalog: function(lang, data) {
    catalogs[lang] = data;
  },

  /**
   * Translate the sentence by a key and replace parameters
   *
   * @example translator.translate('name');
   * @example translate.translate('my name is {name}', {'name': 'Florian'});
   * @param  {string} key
   * @param  {object} [parameters] parameters
   * @returns {string} value
   */
  translate: function(key, parameters = null) {
    let value = key;

    if (catalogs[locale] !== undefined && catalogs[locale][key] !== undefined) {
      value = catalogs[locale][key];
    }

    if (parameters !== undefined) {
      value = this.replace(value, parameters);
    }

    return value;
  },

  /**
   * Add keys/values in the catalag
   *
   * @example translator.translate({'firstname': 'Prénom'}, 'fr');
   * @param {object} data
   * @param {string} lang
   */
  addTransKeys: function(data, lang) {
    if (catalogs[lang]) {
      if (typeof data === 'object') {
        Object.assign(catalogs[lang], data);
      }
    }
  },

  /**
   * Replace parameters from the sentence
   *
   * @example translate.replace('my name is {name}', {'name': 'Florian'});
   * @param  {string} sentence
   * @param  {object} parameters
   * @returns {string} sentence
   */
  replace: function(sentence, parameters) {
    if (typeof parameters === 'string') {
      parameters = JSON.parse(parameters);
    }

    for (let key in parameters) {
      if (parameters.hasOwnProperty(key)) {
        let parameter = parameters[key];
        sentence = sentence.replace('{' + key + '}', parameter);
      }
    }

    return sentence;
  },

  /**
   * Get timezone according to the current language.
   *
   * @returns {string} timezone
   */
  getTimezone: function() {
    return this.getLocale() === 'fr' ? 'fr-FR' : 'en-US';
  },
};
